export default "__VITE_ASSET__D9j9mUmp__"